import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange, totalRecords, handlePages }) => {

    console.log("totalRecords.length", totalRecords);

    const handleChangePage = (id) => {
        handlePages(id)
    }

    const maxDisplayPages = totalPages > 4 ? 4 : totalPages;

    const getPageNumbers = () => {
        const pageNumbers = [];

        let startPage = Math.max(1, currentPage - Math.floor(maxDisplayPages / 2));
        let endPage = Math.min(totalPages, startPage + maxDisplayPages - 1);

        if (endPage - startPage < maxDisplayPages - 1) {
            startPage = endPage - maxDisplayPages + 1;
        }

        if (startPage > 1) {
            pageNumbers.push(1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        if (endPage < totalPages) {
            pageNumbers.push(totalPages);
        }

        return pageNumbers;
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    return (
        <>
            {totalRecords.length > 1 ?
                <nav >
                    <ul className="paginationCustom">
                        <li
                            className={currentPage === 1 ? 'page-item-disabled' : 'page-item'}
                            onClick={handlePrevPage}
                        >
                            <a className={currentPage === 1 ? 'page-item-disabled' : 'page-link'}>«Prev</a>
                        </li>

                        {totalRecords.length && getPageNumbers().map((pageNumber, i) =>
                        (
                            <li className={currentPage == pageNumber ? 'active' : 'page-item'} key={i}>
                                <a className='page-item' onClick={() => handleChangePage(pageNumber)}>{pageNumber}</a>
                            </li>
                        ))}
                        <li
                            className={currentPage === totalPages ? 'page-item-disabled' : 'page-item'}
                            onClick={handleNextPage}
                        >
                            <a className='page-link'>Next»</a>
                        </li>
                    </ul>

                </nav>
                : ""}
        </>
    );
};

export default Pagination;
